import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from '@angular/core';
declare var $: any;

@Component({
    selector: 'app-delete-modal',
    templateUrl: './delete-modal.component.html',
    styleUrls: ['./delete-modal.component.scss'],
    standalone: false
})
export class DeleteModalComponent implements OnInit {
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    this.fnCloseConfirmDeleteModal();
  }

  @Output('delete') delete = new EventEmitter();
  @Output('onClose') onClose = new EventEmitter();

  public deleteElementId: string | number = '';
  public elementType: string = '';
  public showLoader: boolean = false;
  public deleteMessage: string = '';
  public contentMessage: string = '';
  constructor() {}

  fnOpenConfirmDeleteModal(id: any, type: any = '', contentMessage?: string) {
    this.deleteMessage = '';
    this.showLoader = false;
    this.deleteElementId = id;
    this.elementType = type;
    if (contentMessage) {
      this.contentMessage = contentMessage;
    } else {
      this.contentMessage = `Do you really want to delete this record? This process cannot be undone.`;
    }
    $('#confirmDeleteModal').modal('show');
  }

  fnDelete() {
    if (this.deleteElementId != '') {
      if (this.elementType === '') {
        this.delete.emit(this.deleteElementId);
      } else {
        this.delete.emit({
          deleteId: this.deleteElementId,
          type: this.elementType,
        });
      }
      this.showLoader = true;
      setTimeout(() => {
        this.showLoader = false;
        this.deleteMessage = '';
      }, 2000);
      this.fnCloseConfirmDeleteModal();
    }
  }

  fnCloseConfirmDeleteModal() {
    $('#confirmDeleteModal').modal('hide');
  }

  fnCloseConfirmDeleteModalAndEmit() {
    this.fnCloseConfirmDeleteModal();
    if (this.elementType) {
      this.onClose.emit();
    }
  }

  fnShowSuccessDeleteMessage(message: any) {
    this.showLoader = false;
    this.deleteMessage = message;
    setTimeout(() => {
      this.fnCloseConfirmDeleteModal();
    }, 1000);
  }

  ngOnInit(): void {}
}
